import { LfsPointerError, type ResourceError } from "@core-ui/ContextServices/ResourceService/errors";
import { cn } from "@core-ui/utils/cn";
import t from "@ext/localization/locale/translate";
import { Icon } from "@ui-kit/Icon";

export interface ImageErrorProps {
	resourceError?: ResourceError;
}

const getErrorData = (resourceError: ResourceError) => {
	if (resourceError instanceof LfsPointerError) {
		return {
			icon: "cloud-alert",
			title: t("alert.image.unavailable"),
			body: t("git.lfs.file-is-pointer"),
			accentClassName: "text-secondary-fg",
			containerClassName: "border-primary-border bg-primary-bg",
		};
	}

	return {
		icon: "circle-alert",
		title: t("alert.image.unavailable"),
		body: t("alert.image.path"),
		accentClassName: "text-status-error",
		containerClassName: "border-status-error-secondary-border bg-status-error-bg",
	};
};

const ImageError = ({ resourceError }: ImageErrorProps) => {
	const { icon, title, body, accentClassName, containerClassName } = getErrorData(resourceError);

	return (
		<div
			className={cn(
				"main-container my-2 flex min-h-fit min-w-fit max-w-full cursor-default rounded-[var(--radius-small)] border",
				containerClassName,
			)}
			data-focusable="true"
		>
			<div className="flex w-full py-6 pl-6 pr-7">
				<div>
					<p className="flex items-center gap-2">
						<Icon className={cn("[stroke-width:1.25]", accentClassName)} icon={icon} size="lg" />
						<span className={cn("font-medium", accentClassName)}>{title}</span>
					</p>

					<div className="ml-[1.8rem]">{body}</div>
				</div>
			</div>
		</div>
	);
};

export default ImageError;
